import { proxy } from "valtio";

export interface FieldChoice {
  value: string;
  label: string;
}

export interface Field {
  id: number;
  name: string;
  display_name: string;
  field_type: string;
  choices?: readonly FieldChoice[];
  // Dimension axes for an EAV metric (e.g. ["period"]); empty/absent for
  // relational or undimensioned fields (MPN-1200/1201).
  dimension_keys?: readonly string[];
  // Dimension dicts actually observed in this org's data (e.g.
  // [{"period":"2026SP"}]); the validated choices for the per-dimension picker.
  // Empty/absent for undimensioned fields (MPN-1202).
  dimensions?: readonly Record<string, string>[];
  // Display name per catalog code, per axis (MPN-1663): shown in the picker, never stored.
  dimension_value_names?: Record<string, Record<string, string>>;
  // Catalog value groups "is one of" may name instead of a literal list (MPN-2328).
  value_groups?: readonly { code: string; name: string }[];
}

export interface Entity {
  id: number;
  name: string;
  display_name: string;
  lookup_prefix: string;
  fields: readonly Field[];
}

interface AudienceBuilderState {
  organizationId: number | null;
  audienceId: number | null;
  entities: Entity[];
  previewCount: number | null;
  isLoadingEntities: boolean;
  isLoadingPreview: boolean;
  isCalculating: boolean;
}

export const audienceBuilderStore = proxy<AudienceBuilderState>({
  organizationId: null,
  audienceId: null,
  entities: [],
  previewCount: null,
  isLoadingEntities: false,
  isLoadingPreview: false,
  isCalculating: false,
});